import script from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBar.vue?vue&type=style&index=0&id=d3d16eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d16eee"]])

export default __exports__